<script setup>
// GK-HUB: Branded channel icons with official platform colors
import { toRef, computed } from 'vue';
import { useChannelIcon } from './provider';
import Icon from 'next/icon/Icon.vue';
import BrandedChannelSvg from './BrandedChannelSvg.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const channelIcon = useChannelIcon(toRef(props, 'inbox'));

// GK-HUB: Normalize channel type to branded name
const brandedChannel = computed(() => {
  const inboxDetails = props.inbox || {};
  const type = inboxDetails.channel_type;
  const map = {
    'Channel::Whatsapp': 'whatsapp',
    'Channel::Instagram': 'instagram',
    'Channel::Telegram': 'telegram',
    'Channel::FacebookPage': 'messenger',
    'Channel::TwitterProfile': 'twitter',
    'Channel::Line': 'line',
    'Channel::Tiktok': 'tiktok',
  };
  if (type === 'Channel::TwilioSms' && inboxDetails.medium === 'whatsapp') {
    return 'whatsapp';
  }
  if (type === 'Channel::Email' && inboxDetails.provider === 'google') {
    return 'gmail';
  }
  if (type === 'Channel::Email' && inboxDetails.provider === 'microsoft') {
    return 'outlook';
  }
  return map[type] || null;
});
</script>

<template>
  <!-- GK-HUB: Branded SVG icons with official colors -->
  <span v-if="brandedChannel" class="inline-flex items-center justify-center">
    <BrandedChannelSvg :channel="brandedChannel" size-class="size-[1em]" />
  </span>

  <!-- Fallback: original mono icon -->
  <Icon v-else :icon="channelIcon" />
  <!-- GK-HUB: end branded channel icons -->
</template>
